import { handleHttpRequest, http, type HttpResponse } from 'interfaces'
import { type UpdatedOrgResponse } from 'services'

export async function createNewOrg (payload: any): Promise<HttpResponse<UpdatedOrgResponse>> {
  return await handleHttpRequest(http.post('/api/v1/organizations/', payload))
}
